// Bài hướng dẫn màn "Năng suất nhân sự" (QĐ 0386, HRS-230; trần theo máy chia QĐ 0400).
//
// Người mở màn này là người THEO DÕI đội (lead, QC, cửa hàng, điều hành) —
// nhân viên thường không vào. Bài nói cách đọc số và cách lần từ con số ra
// từng việc; không nói số ra từ thao tác nào của phòng nào, không nêu mốc.

import type { GuideBook } from "../types";

export const STAFF_PRODUCTIVITY_GUIDES: GuideBook = {
  staff_productivity: {
    purpose:
      "Xem từng người trong đội đã nhận bao nhiêu việc, xong bao nhiêu, còn dở, quá hạn, bị trả về và còn nhận thêm được bao nhiêu — theo ngày hoặc theo tháng.",
    where: [
      'Hàng lọc ở đầu trang: hai nút "Ngày" và "Tháng", ô "Ngày" (xem theo tháng thì là ô "Tháng"), ô "Cơ sở" và ô "Tìm tên". Trên điện thoại ô "Tìm tên" nằm ngoài, các ô còn lại nằm trong nút "Bộ lọc" — trong đó có thêm ô "Xếp theo".',
      'Hàng nút bộ phận ngay dưới: Chụp, Makeup, Sửa hình, In ấn / album, CSKH, Lễ tân, Thợ phụ. Nút đang tô đậm là bộ phận đang xem; bạn chỉ thấy nút của những bộ phận mình theo dõi. Có thể có thêm nút "Tất cả" đứng đầu hàng.',
      'Các ô tổng bên dưới: số cộng của mọi người đang hiện trong bảng. Khi đang xem một bộ phận, mỗi ô tổng bấm được: bấm vào (ví dụ "Quá hạn nộp") thì khung "Các ca «…»" mở ngay dưới hàng ô tổng, liệt kê mọi ca làm nên con số đó kèm tên người làm, và bảng chính chỉ còn những người có số ở ô đó. Ô đang bấm có viền và dòng "Đang lọc · bấm lại để bỏ".',
      "Bảng chính: mỗi người một dòng — ảnh đại diện, tên và cơ sở bên trái, các cột số bên phải. Trên điện thoại mỗi người là một thẻ, các cột số xếp hai cột trong thẻ.",
      "Bấm vào tên một người: khung chi tiết xổ ra ngay dưới dòng đó, chia nhóm như Nhận việc, Tiến độ, Chất lượng. Chỉ số nào có dấu › thì bấm được để ra danh sách các việc làm nên con số đó; trong danh sách, bấm mã đơn để mở đơn.",
      'Ở Chụp, Makeup và Sửa hình: nút "Chỉnh tạm trần nhận việc" nằm trong khung chi tiết, cạnh dòng ghi trần đang áp.',
    ],
    howItWorks: [
      "Bạn không nhập gì ở trang này: nhân sự làm các thao tác vẫn làm hằng ngày (được xếp lịch, nhận đơn, nộp ảnh, giao ảnh, vào ca…) là con số tự cập nhật sau vài giây.",
      'Xem theo "Ngày" là đếm việc của đúng ngày đó, xem theo "Tháng" là đếm cả tháng. Hai số "Đang dở" và "Quá hạn" (ở Chụp là "Chưa nộp" và "Quá hạn nộp") cũng chỉ đếm việc nhận trong ngày hoặc tháng đang xem — việc nhận ngày khác không chen vào — và cho biết lúc này trong số đó còn bao nhiêu chưa xong, bao nhiêu đã qua hạn. Muốn xem việc còn tồn của cả tháng thì chọn "Tháng".',
      "Mũi tên ▲ hoặc ▼ cạnh một con số là so với hôm trước (khi xem ngày) hoặc tháng trước (khi xem tháng); rê chuột vào mũi tên để đọc số kỳ trước. Mũi tên không mang màu tốt xấu: nhận nhiều lên là tốt, quá hạn nhiều lên là xấu — bạn tự đọc theo cột.",
      'Ô ghi "—" nghĩa là chỉ số đó không áp dụng cho bộ phận này, hoặc trong kỳ chưa có số. Bấm (hoặc rê chuột) vào "—" để đọc lý do.',
      "Bấm tiêu đề một cột để xếp người theo cột đó: lần đầu xếp người nhiều nhất lên trước, bấm lần hai đảo chiều, lần ba trở về thứ tự tên.",
      "Con số và danh sách việc sau nó luôn khớp nhau: số dòng trong danh sách bằng đúng con số bạn vừa bấm.",
      'Bấm một ô tổng là lọc: danh sách "Các ca «…»" gộp ca của mọi người đang hiện trên bảng, theo đúng ngày / tháng và ô "Cơ sở" đang chọn, nên số dòng bằng đúng số trên ô. Một đơn có hai người cùng dính thì hiện hai dòng, mỗi dòng một tên — như ô tổng cũng đếm hai lần. Bấm lại ô đó, hoặc bấm dấu × ở góc khung, là bỏ lọc. Đổi sang bộ phận khác thì lọc tự bỏ.',
      'Việc đã chuyển cho người khác ghi "Đã chuyển người khác" và không còn tính là dở hay quá hạn cho người cũ; đơn khách huỷ cũng ra khỏi dở và quá hạn. Ở Chụp và Makeup, người bị đổi ra khỏi buổi cũng ghi "Đã chuyển người khác" kể cả khi đơn đã sang "Đang chụp" trước lúc đổi — buổi đó và ảnh của buổi đó không tính cho họ, trừ khi chính họ đã thật sự làm buổi đó.',
      "Buổi chụp, buổi trang điểm, buổi thợ phụ và ca lễ tân có từ trước khi trang này bắt đầu đếm mà vẫn chưa xong thì không tính vào đang dở hay quá hạn: đó là đơn cũ chưa ai chuyển bước, không phải việc người đó còn nợ.",
      '"Trả về do lỗi" và "Khách yêu cầu thêm" là hai số riêng: khách xin sửa theo ý mới không bị tính là lỗi của người làm.',
      'Cột "Sức nhận" ở Chụp và Makeup so số buổi hôm nay với trần mà máy chia việc đang áp cho người đó; ở Sửa hình so số ảnh đang ôm với trần ảnh của máy chia. Không ai phải nhập trần: trang đọc thẳng con số máy chia đang dùng.',
      'In ấn / album và CSKH không có máy chia nên không có trần: cột "Sức nhận" ghi số việc đang ôm kèm trung bình của những người đang hiện trên bảng (không tính người nghỉ hôm nay).',
      "Cột này luôn nói về lúc này, kể cả khi đang xem ngày cũ.",
      'Cột "Thiếu ảnh chấm công" ở Chụp, Makeup và Lễ tân đếm số lượt vào ca trong kỳ đã hết hạn nộp ảnh mà còn thiếu ít nhất một bộ ảnh; lượt còn trong hạn chưa tính. Bấm tên người để xem thiếu bộ nào (tác phong, chỗ làm trước ca, nghiệm thu trước khi về) và số lần ra ca sớm.',
      'Ở Chụp, hai cột "Đơn chưa có ảnh check-in" và "Đơn chưa có ảnh in" đếm đơn ảnh thẻ người đó chụp trong kỳ, buổi chụp đã hết giờ mà khối "Ảnh chụp cùng khách" hoặc khối "Ảnh in" của đơn vẫn còn trống. Buổi chưa hết giờ, đơn huỷ và đơn không phải ảnh thẻ chưa tính. Khi bấm tên người, hai số này nằm ở nhóm "Ảnh của đơn ảnh thẻ".',
      'Ở Makeup, hai cột "Đơn chưa có ảnh trước" và "Đơn chưa có ảnh sau" đếm buổi trang điểm trong kỳ đã hết hạn nộp ảnh mà người đó chưa nộp ảnh trước hoặc ảnh sau trang điểm của chính mình. Có nhiều mặt thì mặt nào cũng phải có cả ảnh trước lẫn ảnh sau. Buổi còn trong hạn nộp chưa tính. Khi bấm tên người, hai số này nằm ở nhóm "Ảnh trước / sau trang điểm".',
      "Bốn cột ảnh của đơn đổi ngay khi ảnh được tải lên — tải lại trang là thấy, không phải đợi.",
      'Khối Chụp có nhóm "Sửa ảnh thẻ" khi bấm tên người: "Ảnh thẻ đã sửa" đếm số tấm ảnh thẻ người đó nộp bản sửa trong kỳ (một tấm nộp lại nhiều lần vẫn tính một), "Đơn sửa nhận ở khối chung" đếm đơn người khác chụp mà người đó nhận sửa ở trang Việc thợ chụp. Hai số này chỉ để theo dõi.',
      "Trang chỉ để xem và theo dõi: không đổi điểm của ai, không đổi việc ai đang làm.",
    ],
    statuses: [
      {
        label: "Có việc quá hạn",
        meaning:
          "Nhãn đỏ dưới tên: trong số việc nhận ở ngày hoặc tháng đang xem, người này còn việc đã qua hạn mà chưa xong.",
      },
      {
        label: "Có ca chưa chấm công",
        meaning: "Nhãn đỏ dưới tên (Lễ tân): có ca đã tới giờ mà chưa vào ca.",
      },
      {
        label: "Kín sức nhận",
        meaning: "Nhãn đỏ dưới tên: số việc đang ôm đã chạm trần máy chia đang áp.",
      },
      {
        label: "Ôm việc gấp đôi TB phòng",
        meaning:
          "Nhãn đỏ dưới tên (In ấn / album, CSKH): số việc đang ôm từ gấp đôi trung bình phòng trở lên.",
      },
      {
        label: "Thiếu ảnh chấm công",
        meaning:
          "Nhãn vàng dưới tên (Chụp, Makeup, Lễ tân): trong kỳ có lượt vào ca đã hết hạn nộp ảnh mà còn thiếu ảnh tác phong, ảnh chỗ làm trước ca hoặc ảnh nghiệm thu trước khi về.",
      },
      {
        label: "Điểm QC thấp",
        meaning: "Nhãn đỏ dưới tên: điểm QC trung bình trong kỳ thấp hơn mức công ty đặt.",
      },
      {
        label: "Số tô nền đỏ",
        meaning: "Việc cần xử lý ngay, ví dụ đang quá hạn hoặc đã kín sức nhận.",
      },
      { label: "Số tô nền vàng", meaning: "Cần để ý, ví dụ bị trả về do lỗi." },
      {
        label: "2/3 · kín",
        meaning:
          'Ở cột "Sức nhận": số đang ôm trên trần đang áp (Sửa hình ghi thêm chữ "ảnh"); chữ "kín" hiện khi đã chạm trần. Rê chuột vào số để biết trần đó của máy chia hay do lead chỉnh tạm.',
      },
      {
        label: "máy chia không giới hạn",
        meaning: 'Ở cột "Sức nhận": máy chia không đặt trần cho người này nên chỉ hiện số đang ôm.',
      },
      {
        label: "chưa đọc được trần máy chia",
        meaning:
          'Ở cột "Sức nhận": trang chưa hỏi được trần máy chia lúc này — tải lại trang; còn ghi vậy thì báo quản lý trực tiếp.',
      },
      {
        label: "TB phòng",
        meaning:
          'Ở cột "Sức nhận" (In ấn / album, CSKH): trung bình số việc đang ôm của những người đang hiện trên bảng. Số tô vàng khi gấp rưỡi trung bình, tô đỏ và ghi "gấp … lần" khi gấp đôi.',
      },
      {
        label: "Đang nghỉ",
        meaning: 'Ở cột "Sức nhận": hôm nay người này nghỉ hoặc đang tạm dừng nhận việc.',
      },
      {
        label: "—",
        meaning:
          "Chỉ số không áp dụng cho bộ phận này, hoặc trong kỳ chưa có số; bấm vào để đọc lý do.",
      },
      { label: "Đang dở", meaning: "Trong danh sách việc: việc đã nhận, chưa xong, chưa tới hạn." },
      { label: "Quá hạn", meaning: "Trong danh sách việc: việc chưa xong mà đã qua hạn." },
      {
        label: "Xong",
        meaning: "Trong danh sách việc: việc đã xong kịp hạn (hoặc việc không có hạn).",
      },
      { label: "Xong trễ", meaning: "Trong danh sách việc: việc đã xong nhưng sau hạn." },
      {
        label: "Sắp tới",
        meaning: "Trong danh sách việc: buổi hoặc ca đã xếp nhưng chưa tới giờ.",
      },
      {
        label: "Đang làm lại theo khách",
        meaning:
          "Trong danh sách việc: khách xin sửa thêm, việc đang được làm lại. Việc này chỉ tính quá hạn khi đã qua hạn của vòng sửa (tính từ lúc khách xin, theo giờ làm việc) — không tính theo hạn giao lần đầu.",
      },
      {
        label: "Đã chuyển người khác",
        meaning:
          "Trong danh sách việc: việc đã giao sang người khác (kể cả buổi chụp / trang điểm người này bị đổi ra trước khi làm), không tính cho người này nữa.",
      },
      { label: "Bị huỷ", meaning: "Trong danh sách việc: đơn hoặc buổi đã huỷ." },
      {
        label: "Chưa có ảnh",
        meaning:
          'Trong danh sách việc của hai cột "Đơn chưa có ảnh check-in" / "Đơn chưa có ảnh in": buổi chụp đã hết giờ mà khối ảnh đó của đơn vẫn trống.',
      },
      {
        label: "Quá hạn nộp ảnh",
        meaning:
          'Trong danh sách việc của hai cột "Đơn chưa có ảnh trước" / "Đơn chưa có ảnh sau": đã qua hạn nộp ảnh trang điểm mà người đó chưa nộp đủ. Cột "Hạn" ghi hạn nộp.',
      },
    ],
    blocks: [
      {
        for: ["lead", "qc"],
        title: "Theo dõi đội của bạn mỗi ngày",
        steps: [
          'Mở trang: trang đứng sẵn ở "Ngày" hôm nay và ở bộ phận đầu tiên bạn theo dõi.',
          "Đọc các ô tổng để biết cả đội đang dở bao nhiêu việc, quá hạn bao nhiêu.",
          'Bấm ô tổng cần xử lý (ví dụ "Quá hạn nộp" hoặc "Chưa nộp"): khung "Các ca «…»" hiện mọi ca đang như vậy kèm tên người làm, bảng chỉ còn những người dính. Bấm mã đơn để mở đơn và xử lý; xong thì bấm lại ô tổng để bỏ lọc.',
          "Nhìn các nhãn đỏ dưới tên: người có việc quá hạn, kín sức nhận hoặc điểm QC thấp.",
          "Bấm tiêu đề cột quá hạn (hoặc cột đang dở) để đưa người cần xử lý lên đầu bảng.",
          "Bấm tên người đó để xổ chi tiết, bấm chỉ số quá hạn để ra danh sách việc, rồi bấm mã đơn để mở đơn và xử lý.",
          'Cuối tháng bấm "Tháng" để xem cả tháng; mũi tên ▲▼ cho biết tăng hay giảm so với tháng trước.',
          'Ở Chụp và Makeup, bấm tiêu đề cột "Đơn chưa có ảnh …" để đưa người còn nợ ảnh của đơn lên đầu; bấm số để ra đúng các đơn, bấm mã đơn để mở đơn và nhắc người đó tải ảnh.',
        ],
        troubles: [
          'Không thấy một người: người đó không thuộc phòng hay cơ sở bạn theo dõi, hoặc ô "Cơ sở" / ô "Tìm tên" / một ô tổng đang lọc (ô tổng đang lọc có viền và dòng "Đang lọc") — xoá lọc rồi xem lại.',
          'Bấm ô tổng mà bảng báo "Không có ai có số ở thẻ …": trong ngày hoặc tháng đang xem không ai đang như vậy — bấm lại ô đó để bỏ lọc.',
          "Con số khác với số bạn tự đếm: bấm vào con số để xem đúng danh sách việc làm nên nó.",
          'Cột ảnh của đơn ghi "—": trong kỳ chưa có buổi nào tới lúc phải có ảnh (buổi chụp chưa hết giờ, buổi trang điểm còn trong hạn nộp, hoặc người đó không chụp đơn ảnh thẻ nào).',
          "Đã tải ảnh mà đơn vẫn nằm trong danh sách: ảnh trước / sau trang điểm phải do chính người đó tải và đủ cho mọi mặt; tải lại trang để xem số mới.",
          "Thao tác vừa làm mà con số chưa đổi: đợi vài giây rồi tải lại trang.",
          "Trang báo không xem được bộ phận này: phần việc của bạn không gồm bộ phận đó — hỏi quản lý trực tiếp.",
        ],
      },
      {
        for: ["lead"],
        title: "Chỉnh tạm trần nhận việc cho một người",
        steps: [
          "Dùng khi một người cần nhận ít hoặc nhiều hơn bình thường trong ít ngày (người mới, đang ốm, đang kèm việc khác).",
          "Mở bộ phận Chụp, Makeup hoặc Sửa hình, bấm tên người đó để xổ khung chi tiết; dòng cạnh nút ghi trần máy chia đang áp.",
          'Bấm "Chỉnh tạm trần nhận việc". Gõ trần mới (Chụp, Makeup: số suất mỗi ngày; Sửa hình: số ảnh) và chọn ô "Hết ngày", rồi bấm "Lưu".',
          "Từ lúc lưu, máy chia giao việc cho người đó theo đúng số bạn vừa chỉnh. Qua hết ngày đã chọn, trần tự quay về số của máy chia — không cần nhớ gỡ.",
          'Muốn thôi sớm thì mở lại hộp và bấm "Bỏ chỉnh tạm".',
        ],
        troubles: [
          'Không thấy nút "Chỉnh tạm trần nhận việc": bộ phận đang xem không có máy chia (In ấn / album, CSKH, Lễ tân, Thợ phụ), hoặc phần việc của bạn ở trang này là xem — hỏi quản lý trực tiếp.',
          "Hộp báo số hoặc ngày không hợp lệ: gõ số nguyên trong khoảng hộp ghi và chọn ngày trong khoảng hộp cho phép, rồi lưu lại.",
        ],
      },
      {
        for: ["exec"],
        title: "Nhìn cả công ty rồi lần xuống từng người",
        steps: [
          'Bấm nút "Tất cả": mỗi bộ phận một dòng với số người, nhận, xong, đang dở, đang quá hạn, trả về do lỗi.',
          "Bộ phận nào có số quá hạn tô đỏ thì bấm vào dòng đó để vào bảng của bộ phận.",
          "Trong bảng bộ phận, bấm tiêu đề cột để xếp người, bấm tên để xổ chi tiết, bấm chỉ số để ra danh sách việc.",
          'Muốn thấy ngay mọi ca đang quá hạn của bộ phận: bấm ô tổng "Quá hạn" (ở Chụp là "Quá hạn nộp") — khung "Các ca «…»" liệt kê từng ca kèm tên người làm; bấm lại ô đó để bỏ lọc.',
          'Dùng ô "Cơ sở" để xem riêng một cơ sở.',
          'Cần một người nhận ít hoặc nhiều hơn trần máy chia trong ít ngày: bấm tên người đó rồi bấm "Chỉnh tạm trần nhận việc".',
        ],
        troubles: [
          'Một bộ phận ghi 0 người: trong kỳ chưa ai của bộ phận đó có việc, hoặc ô "Cơ sở" đang lọc.',
          "Số của tháng trước khác lần xem trước: có việc được cập nhật trễ — bấm vào con số để xem danh sách việc hiện tại.",
        ],
      },
    ],
    askWho:
      "Số trông sai hoặc thiếu người: chụp màn hình kèm tên người và ngày đang xem, gửi quản lý trực tiếp.",
  },
};
